var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnNotificationservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6807_12064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7461 10.5472V6C17.7461 5.58579 17.4103 5.25 16.9961 5.25H16.2461C14.7621 6.73398 11.9731 7.56546 10.2461 7.95961V16.0404C11.9731 16.4345 14.7621 17.2661 16.2461 18.75H16.9961C17.4103 18.75 17.7461 18.4142 17.7461 18V13.4528C18.393 13.2863 18.8711 12.6989 18.8711 12C18.8711 11.3011 18.393 10.7137 17.7461 10.5472ZM5.74609 8.25C4.91767 8.25 4.24609 8.92157 4.24609 9.75V14.25C4.24609 15.0785 4.91767 15.75 5.74609 15.75H6.49609L7.24609 19.5H8.74609V8.25H5.74609Z",
    fill: "#262949"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 2.5,
    fill: "#EA7E68",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6807_12064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNotificationservice);
export default __webpack_public_path__ + "static/media/icn-notificationservice.1bd4ee63d18d83d6f55eca4f03fe9d33.svg";
export { ForwardRef as ReactComponent };